/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Element } from 'react';

import React from 'react';
import { Form } from 'reactstrap';
import {
  ZOOM_LEVEL_DAM_INUNDATION, // zoomLevelDamInundation
  ZOOM_LEVEL_FAULT_RUPTURE, // zoomLevelFaultRupture
  ZOOM_LEVEL_LANDSLIDE, // zoomLevelLandslide
  ZOOM_LEVEL_LIQUEFACTION, // zoomLevelLiquefaction
  ZOOM_LEVEL_NEARBY_FAULTS, // zoomLevelNearbyFaults
  ZOOM_LEVEL_SHAKE_MAPS, // zoomLevelShakeMaps
  ZOOM_LEVEL_SOIL, // zoomLevelSoil
  ZOOM_LEVEL_TSUNAMI, // zoomLevelTsunami
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import BackButton from '#components/pages/Models/Model/sections/support/buttons/BackButton.jsx';
import NextButton from '#components/pages/Models/Model/sections/support/buttons/NextButton.jsx';
import {
  Field,
  FormGroup,
  Fieldset,
  FormGroupCol as Col,
} from '#components/pages/Models/Model/support/form/index.js';

type Props = {|
  fieldsByName: Object,
  form: string,
  heading: string,
  onBack: Function,
  onNext: Function,
|};

const MapSettingsSection = ({
  fieldsByName,
  form,
  heading,
  onBack,
  onNext,
}: Props): Element<'div'> => (
  <div>
    <h2>{heading}</h2>
    <p>
      These settings control how closely each hazard map is zoomed in around the site location on
      the generated report.
    </p>
    <Form noValidate>
      <Fieldset>
        <legend>Map Zoom Levels</legend>
        <FormGroup form={form} fields={[ZOOM_LEVEL_SOIL]} row>
          <Col lg="6">
            <Field field={fieldsByName[ZOOM_LEVEL_SOIL]} />
          </Col>
        </FormGroup>
        <FormGroup form={form} fields={[ZOOM_LEVEL_LIQUEFACTION]} row>
          <Col lg="6">
            <Field field={fieldsByName[ZOOM_LEVEL_LIQUEFACTION]} />
          </Col>
        </FormGroup>
        <FormGroup form={form} fields={[ZOOM_LEVEL_LANDSLIDE]} row>
          <Col lg="6">
            <Field field={fieldsByName[ZOOM_LEVEL_LANDSLIDE]} />
          </Col>
        </FormGroup>
        <FormGroup form={form} fields={[ZOOM_LEVEL_FAULT_RUPTURE]} row>
          <Col lg="6">
            <Field field={fieldsByName[ZOOM_LEVEL_FAULT_RUPTURE]} />
          </Col>
        </FormGroup>
        <FormGroup form={form} fields={[ZOOM_LEVEL_TSUNAMI]} row>
          <Col lg="6">
            <Field field={fieldsByName[ZOOM_LEVEL_TSUNAMI]} />
          </Col>
        </FormGroup>
        <FormGroup form={form} fields={[ZOOM_LEVEL_NEARBY_FAULTS]} row>
          <Col lg="6">
            <Field field={fieldsByName[ZOOM_LEVEL_NEARBY_FAULTS]} />
          </Col>
        </FormGroup>
        <FormGroup form={form} fields={[ZOOM_LEVEL_SHAKE_MAPS]} row>
          <Col lg="6">
            <Field field={fieldsByName[ZOOM_LEVEL_SHAKE_MAPS]} />
          </Col>
        </FormGroup>
        <FormGroup form={form} fields={[ZOOM_LEVEL_DAM_INUNDATION]} row>
          <Col lg="6">
            <Field field={fieldsByName[ZOOM_LEVEL_DAM_INUNDATION]} />
          </Col>
        </FormGroup>
      </Fieldset>
      <BackButton onClick={onBack} />
      <NextButton onClick={onNext} />
    </Form>
  </div>
);

export default MapSettingsSection;
